module.exports = "<div class=\"search-zero-results-wrapper\">\r\n    <h1 class=\"search-zero-results-wrapper-header\">No {{pageName}} found</h1>\r\n    <div class=\"search-zero-results-wrapper-blurb\">\r\n        <span ng-bind-html=\"EmptyProductSearchMessageBefore\"></span>\r\n        {{ SearchTerm }}\r\n        <span ng-bind-html=\"EmptyProductSearchMessageAfter\"></span>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/search/search-zero-results.directive.html
// module id = 531
// module chunks = 0